import { render, staticRenderFns } from "./DebtPayingAbilityTabs.vue?vue&type=template&id=0e89858c&scoped=true"
import script from "./DebtPayingAbilityTabs.vue?vue&type=script&lang=js"
export * from "./DebtPayingAbilityTabs.vue?vue&type=script&lang=js"
import style0 from "./DebtPayingAbilityTabs.vue?vue&type=style&index=0&id=0e89858c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e89858c",
  null
  
)

export default component.exports